export default "__VITE_ASSET__DZyYPexB__"